import React from 'react';
import { ExpandableMenuProps } from 'src/app/molecules/Header/Header/HeaderLinks';
import MegaMenu from 'molecules/Header/MegaMenu/MegaMenuContainer';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Typography from 'src/app/atoms/Typography/Typography';
import MightyProMegaMenuFeatures from './MightyProMegaMenuFeatures';
import Clickable from 'atoms/Clickable/Clickable';

const MightyProMegaMenu = ({ isOpen, onClose }: ExpandableMenuProps): JSX.Element => {
  return (
    <MegaMenu
      isOpen={isOpen}
      onClose={onClose}
      padding={'spacing-md'}
    >
      <MightyProMegaMenuFeatures />
      <Stack
        direction='row'
        align='center'
        justify='center'
        gap={'spacing-md'}
        background='bg-secondary'
        padding={'spacing-2xl'}
      >
        <Typography
          type='paragraph'
          size='md'
          fontWeight='font-weight-medium'
          color='text-tertiary'
        >
          Ready to move to Mighty?
        </Typography>
        <Clickable href='/migration-form'>
          <Typography
            type='paragraph'
            size='md'
            fontWeight='font-weight-semibold'
            color='text-brand-secondary'
          >
            Apply for a free migration
          </Typography>
        </Clickable>
      </Stack>
    </MegaMenu>
  );
};

export default MightyProMegaMenu;
